import { render, staticRenderFns } from "./ShowerConfigurator.vue?vue&type=template&id=4761769e&"
import script from "./ShowerConfigurator.ts?vue&type=script&lang=js&"
export * from "./ShowerConfigurator.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports